import styled from 'styled-components/macro';

import { colors, margins } from 'css/css';

export const LineBreak = styled.hr`
  height: 1px;
  color: ${colors.primaryLight};
  margin-bottom: ${margins.size3};
`;
